export const strings = {
  NAME: "Link card",
  DESCRIPTION: "Link to a website or resource.",
} as const;
